import React, {Component} from 'react';
import {Link,NavLink,Redirect} from 'react-router-dom';
import M from  'materialize-css/dist/js/materialize.min.js';
import 'materialize-css/dist/css/materialize.min.css';
import auth from '../Auth'

class SideNav extends Component {
    state={
        username:'Akshay',
        email:'some@gmail.com',
        isRedirect:false
    }
    componentDidMount() {
        let sidenav = document.querySelector('#slide-out');
        M.Sidenav.init(sidenav, {});
         // Initialize collapsible (uncomment the lines below if you use the dropdown variation)
        var collapsibleElem = document.querySelector('.collapsible');
        M.Collapsible.init(collapsibleElem, {});
        var collapsibleElem2 = document.querySelector('.collapsible2');
        M.Collapsible.init(collapsibleElem2, {});
        this.setUser();
    }
    handlerClick=()=>{
        let sidenav = document.querySelector('#slide-out');
       M.Sidenav.init(sidenav, {}).close();
    }
    setUser(){
        if(auth.isValid){
           let data = JSON.parse(localStorage.getItem('userDetails'))
        //    console.log(data)
            this.setState({
                username:data.firstName,
                email:data.email,
            })
        }
    }

    onLogout=()=>{
        this.handlerClick();
        auth.logout(()=>{this.setState({isRedirect:true})})
    }

    render() {
      const url = this.props.match.url
        return(
            <div className="mySidebar" >
             {this.state.isRedirect?<Redirect to="/"/>:null}
            <ul id="slide-out" className="sidenav sidenav-fixed">
                <li><div className="user-view">
                <div className="background  grey darken-1">
                    <img alt="logo" src="https://myclouddoor.com/wp-content/uploads/2016/07/tech-background-image-1-1.jpg"/>
                </div>
                <span ><img alt="user-logo" src="https://img.icons8.com/bubbles/50/000000/admin-settings-male.png"/></span>
                
                <span><span className="white-text name">{this.state.username} (Nirmal Labs)</span></span>
                <span ><span className="white-text email">{this.state.email}</span></span>
                </div>
                </li>
                {/* <li><div className="center">
                <div className="">
                   <span className="brand-logo sidenav-logo">Nirmal Labs</span>
                </div>
                </div></li> */}
            
                <li><Link to={`${url}/dashboard`} className="waves-effect" onClick={this.handlerClick}><i className="material-icons  right"  style={{'color':'#448aff'}}>dashboard</i>Dashboard</Link></li>
                <li><div className="divider"></div></li>
                <li className="no-padding">
                <ul className="collapsible collapsible-accordion">
                <li>
                    <Link to='#' className="collapsible-header waves-effect">Manage Publishers<i className="material-icons right" style={{'color':'#00796b'}}>arrow_drop_down</i></Link>
                    <div className="collapsible-body">
                    <ul>
                        <li><NavLink to={`${url}/publishers`} onClick={this.handlerClick}>Publishers <i className="material-icons right" style={{'color':'#f50057'}}>rowing</i></NavLink></li>
                    </ul>
                    </div>
                </li>

                 <li>
                    <Link to='#' className="collapsible-header waves-effect">Notifications<i className="material-icons right" style={{'color':'#00796b'}}>arrow_drop_down</i></Link>
                    <div className="collapsible-body">
                    <ul>
                        <li><NavLink to={`${url}/CreateNotification`} onClick={this.handlerClick}>Create Notification <i className="material-icons right" style={{'color':'#f50057'}}>add </i></NavLink></li>
                        <li><NavLink to={`${url}/NotificationHistory`} onClick={this.handlerClick}>Notification History<i className="material-icons right" style={{'color':'#afb42b'}}>history</i></NavLink></li>
                    </ul>
                    </div>
                </li>
                <li>
                    <Link to='#' className="collapsible-header waves-effect">Manage Apps<i className="material-icons right" style={{'color':'#00796b'}}>arrow_drop_down</i></Link>
                    <div className="collapsible-body">
                    <ul>
                        <li><NavLink to={`${url}/AddApp`} onClick={this.handlerClick}>Add New <i className="material-icons right" style={{'color':'#00b0ff'}}>add </i></NavLink></li>
                        <li><NavLink to={`${url}/AppDetails`} onClick={this.handlerClick}>Apps<i className="material-icons right" style={{'color':'#ff8f00'}}>apps</i></NavLink></li>
                    </ul>
                    </div>
                </li>

                <li>
                    <Link to='#' className="collapsible-header waves-effect">Manage CalendarApp<i className="material-icons right" style={{'color':'#00796b'}}>arrow_drop_down</i></Link>
                    <div className="collapsible-body">
                    <ul>
                      <li onClick={this.handlerClick}><NavLink to={`${url}/CalendarApp/AddHoroscope`}>Update horoscope<i className="material-icons right" style={{'color':'#f50157'}}>add</i></NavLink></li>
                      <li onClick={this.handlerClick}><NavLink to={`${url}/CalendarApp/ViewHoroscope`}>View Daily Horoscope <i className="material-icons right" style={{'color':'#f50057'}}>pageview </i></NavLink></li>
                    </ul>
                    </div>
                </li>
                
                
                <li>
                    <Link to='#' className="collapsible-header waves-effect">Settings<i className="material-icons right" style={{'color':'#00796b'}}>arrow_drop_down</i></Link>
                    <div className="collapsible-body">
                    <ul>
                        <li><NavLink to={`${url}/AddMember`} onClick={this.handlerClick}>Member<i className="material-icons right" style={{'color':'#e64a19 '}}>supervisor_account</i></NavLink></li>
                        <li><NavLink to="#" onClick={this.onLogout}>Logout<i className="material-icons right" style={{'color':'#2196f3'}}>logout</i></NavLink></li>
                    </ul>
                    </div>
                </li>
                </ul>
                </li>
            </ul>
            {/* <Link to="/" data-target="slide-out" className="sidenav-trigger"><i className="material-icons">menu</i></Link> */}
            </div>
        );
    }
}

export default SideNav;